import { faCog, faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'
import { faSalesforce } from '@fortawesome/free-brands-svg-icons'

import { pathWithRedirect } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useAgency'

import type { AgencyModel } from '@models/types'

type GenerateTabBarItemsParams = {
  agency: AgencyModel,
  isBrandUser?: boolean,
}
const generateTabBarItems = (params: GenerateTabBarItemsParams) => {
  const { agency, isBrandUser } = params

  const urls = generateUrls(agency)
  const {
    agencySalesforceDetailsUrl, editAgencyIntegrationsUrl, editAgencyRelationsUrl, editAgencyUrl,
  } = urls

  const hasSalesforceId = !!agency?.salesforce_id

  return [
    {
      icon: faIdCard,
      href: pathWithRedirect(editAgencyUrl),
      key: 'details',
      title: agency?.short_name || 'Agency Details',
    },
    {
      icon: faToggleOn,
      href: pathWithRedirect(editAgencyRelationsUrl),
      key: 'relations',
      title: 'Agency Relations',
    },
    {
      icon: faCog,
      href: pathWithRedirect(editAgencyIntegrationsUrl),
      hidden: !isBrandUser,
      key: 'integrations',
      title: 'Integrations',
    },
    {
      icon: faSalesforce,
      href: pathWithRedirect(agencySalesforceDetailsUrl),
      hidden: !hasSalesforceId,
      key: 'salesforceDetails',
      title: 'Salesforce Details',
    },
  ]
}

export default generateTabBarItems
